(function () {
  'use strict';

  var DEFAULT_MAPS_KEY = 'AIzaSyAEY5R902_gyPQQ8QqJiDe-rpu2x6naPDw';
  var MAPS_CALLBACK = '__custDeliveryMapsBoot';
  var DEFAULT_MAP_CONSENT_HINT =
    'Um die Karte anzuzeigen, müssen Sie Cookies akzeptieren und die Seite anschließend neu laden.';

  function mapsReady() {
    return !!(window.google && window.google.maps && window.google.maps.Map);
  }

  function waitForMaps(timeoutMs) {
    return new Promise(function (resolve, reject) {
      if (mapsReady()) {
        resolve(window.google.maps);
        return;
      }

      var started = Date.now();
      var timer = setInterval(function () {
        if (mapsReady()) {
          clearInterval(timer);
          resolve(window.google.maps);
          return;
        }
        if (Date.now() - started > timeoutMs) {
          clearInterval(timer);
          reject(new Error('Google Maps timed out'));
        }
      }, 100);
    });
  }

  function bindConsentRetry(callback) {
    if (typeof window.__cmp !== 'function') return;
    try {
      window.__cmp('addEventListener', ['consent', callback, false]);
      window.__cmp('addEventListener', ['consentcustom', callback, false]);
    } catch (err) {
      /* ignore */
    }
  }

  function loadGoogleMaps(apiKey) {
    if (mapsReady()) return Promise.resolve(window.google.maps);

    return new Promise(function (resolve, reject) {
      var key = apiKey || DEFAULT_MAPS_KEY;
      var settled = false;

      function done(maps) {
        if (settled) return;
        settled = true;
        resolve(maps);
      }

      function fail(err) {
        if (settled) return;
        settled = true;
        reject(err);
      }

      window[MAPS_CALLBACK] = function () {
        done(window.google.maps);
      };

      var existing = document.querySelector('script[data-cust-delivery-maps]');
      if (existing) {
        waitForMaps(15000).then(done).catch(fail);
        return;
      }

      var script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(key) +
        '&callback=' +
        MAPS_CALLBACK;
      script.async = true;
      script.defer = true;
      script.setAttribute('data-cust-delivery-maps', 'true');
      script.onerror = function () {
        fail(new Error('Failed to load Google Maps'));
      };
      document.head.appendChild(script);
      waitForMaps(20000).then(done).catch(fail);
    });
  }

  /* InsCoder WANG.J 2026-10-29 B + Safely render pickup details and validate map coordinates */
  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function hasValidCoordinates(loc) {
    return isFinite(loc.lat) && Math.abs(loc.lat) <= 90 && isFinite(loc.lng) && Math.abs(loc.lng) <= 180;
  }
  /* InsCoder WANG.J 2026-10-29 E + Safely render pickup details and validate map coordinates */

  function parseLocations(root) {
    var jsonEl = root.querySelector('[data-pickup-locations-json]');
    if (!jsonEl) return [];
    try {
      var raw = JSON.parse(jsonEl.textContent || '[]');
      if (!Array.isArray(raw)) return [];
      return raw
        .map(function (loc, index) {
          return {
            index: loc.index != null ? loc.index : index,
            city: loc.city || '',
            address: loc.address || '',
            lat: parseFloat(loc.lat),
            lng: parseFloat(loc.lng),
            openingHours: loc.opening_hours || loc.openingHours || '',
            customerService: loc.customer_service || loc.customerService || ''
          };
        })
        .filter(function (loc) {
          return loc.city || loc.address;
        });
    } catch (err) {
      console.error('[cust-delivery-method] Failed to parse pickup locations JSON', err);
      return [];
    }
  }

  function DeliveryMethod(root) {
    this.root = root;
    this.options = root.querySelectorAll('[data-delivery-option]');
    this.mapPanel = root.querySelector('[data-delivery-modal-panel="map"]');
    this.notePanel = root.querySelector('[data-delivery-modal-panel="note"]');
    this.mapEl = root.querySelector('[data-pickup-map]');
    this.locationSelect = root.querySelector('[data-pickup-location-select]');
    this.locationBtns = root.querySelectorAll('[data-pickup-location]');
    this.moreInfoText = root.getAttribute('data-more-info-text') || 'Weitere Informationen';
    this.apiKey = root.getAttribute('data-google-maps-key') || DEFAULT_MAPS_KEY;
    this.mapConsentHint = root.getAttribute('data-map-consent-hint') || DEFAULT_MAP_CONSENT_HINT;
    this.locations = parseLocations(root);
    this.isStandalone = root.hasAttribute('data-cust-pickup-map-standalone');
    this.map = null;
    this.markers = [];
    this.infoWindow = null;
    this.locationBounds = null;
    this._destroyed = false;
    this._listeners = [];
    this._mapInitStarted = false;
    this.buildLocationSelect();
    this.bind();

    if (this.isStandalone) {
      this.initMap();
    }
  }

  DeliveryMethod.prototype.buildLocationSelect = function () {
    var wrap = this.root.querySelector('[data-pickup-location-select-wrap]');
    var select = this.root.querySelector('[data-pickup-location-select]');
    if (!wrap || !select || !this.locationBtns.length) return;

    select.innerHTML = '';
    /* InsCoder WANG.J 2026-10-29 B + Keep the mobile selector in the all-locations state initially */
    var overviewOption = document.createElement('option');
    overviewOption.value = '';
    overviewOption.textContent = select.getAttribute('data-all-locations-label');
    select.appendChild(overviewOption);
    /* InsCoder WANG.J 2026-10-29 E + Keep the mobile selector in the all-locations state initially */
    this.locationBtns.forEach(function (btn) {
      var city = btn.getAttribute('data-city') || '';
      var address = btn.getAttribute('data-address') || '';
      var label = city;
      if (address) {
        label = city ? city + ' - ' + address : address;
      }

      var option = document.createElement('option');
      option.value = btn.getAttribute('data-index');
      option.textContent = label;
      if (btn.classList.contains('is-active')) {
        option.selected = true;
      }
      select.appendChild(option);
    });
  };

  DeliveryMethod.prototype.bind = function () {
    var self = this;
    function listen(element, type, handler) {
      element.addEventListener(type, handler);
      self._listeners.push({ element: element, type: type, handler: handler });
    }

    this.options.forEach(function (option) {
      var radio = option.querySelector('.cust-delivery-method__radio');
      if (!radio) return;
      listen(radio, 'change', function () {
        self.selectOption(option.getAttribute('data-delivery-option'));
      });
    });

    listen(this.root, 'click', function (event) {
      var toggle = event.target.closest('.cust-delivery-modal__location-toggle');
      if (toggle && self.root.contains(toggle)) {
        event.preventDefault();
        event.stopPropagation();
        self.toggleLocationDetails(toggle);
        return;
      }

      var link = event.target.closest(
        '[data-delivery-modal], a[href="#ef-modal-map"], a[href="#ef-modal-note"], a[href="#ef-modal-pickup-map"], a[href="#ef-modal-pickup-note"]'
      );
      if (!link || !self.root.contains(link)) return;
      event.preventDefault();
      event.stopPropagation();
      var type = link.getAttribute('data-delivery-modal');
      if (!type) {
        var href = link.getAttribute('href') || '';
        if (href.indexOf('map') !== -1) type = 'map';
        else if (href.indexOf('note') !== -1) type = 'note';
      }
      self.openModal(type);
    });

    this.root.querySelectorAll('[data-delivery-modal-close]').forEach(function (el) {
      listen(el, 'click', function () {
        self.closeModals();
      });
    });

    this.locationBtns.forEach(function (btn) {
      listen(btn, 'click', function (event) {
        if (
          event.target.closest('[data-pickup-info-link]') ||
          event.target.closest('.cust-delivery-modal__location-toggle') ||
          event.target.closest('.cust-delivery-modal__location-details')
        ) {
          return;
        }
        self.activateLocation(btn);
      });
      listen(btn, 'keydown', function (event) {
        if (
          event.target.closest('[data-pickup-info-link]') ||
          event.target.closest('.cust-delivery-modal__location-toggle') ||
          event.target.closest('.cust-delivery-modal__location-details')
        ) {
          return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          self.activateLocation(btn);
        }
      });
    });

    listen(document, 'keydown', function (event) {
      if (event.key === 'Escape') self.closeModals();
    });

    if (this.locationSelect) {
      listen(this.locationSelect, 'change', function () {
        if (self.locationSelect.value === '') {
          self.showAllLocations();
          return;
        }
        var btn = self.root.querySelector(
          '[data-pickup-location][data-index="' + self.locationSelect.value + '"]'
        );
        if (btn) self.activateLocation(btn);
      });
    }
  };

  DeliveryMethod.prototype.selectOption = function (type) {
    this.options.forEach(function (option) {
      var isActive = option.getAttribute('data-delivery-option') === type;
      option.classList.toggle('is-selected', isActive);
      var radio = option.querySelector('.cust-delivery-method__radio');
      if (radio) radio.checked = isActive;
    });
  };

  DeliveryMethod.prototype.openModal = function (type) {
    this.closeModals();
    var panel = type === 'map' ? this.mapPanel : type === 'note' ? this.notePanel : null;
    if (!panel) return;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    if (type === 'map') this.initMap();
  };

  DeliveryMethod.prototype.closeModals = function () {
    [this.mapPanel, this.notePanel].forEach(function (panel) {
      if (!panel) return;
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
    });
  };

  DeliveryMethod.prototype.toggleLocationDetails = function (toggle) {
    var location = toggle.closest('[data-pickup-location]');
    if (!location) return;
    var details = location.querySelector('.cust-delivery-modal__location-details');
    if (!details) return;

    var isHidden = details.hasAttribute('hidden');
    if (isHidden) {
      details.removeAttribute('hidden');
      toggle.textContent = toggle.getAttribute('data-hide-text') || 'Ausblenden Informationen';
    } else {
      details.setAttribute('hidden', '');
      toggle.textContent = toggle.getAttribute('data-show-text') || 'Weitere Informationen';
    }
  };

  DeliveryMethod.prototype.buildPopupHtml = function (loc) {
    /* InsCoder WANG.J 2026-10-29 B + Include escaped multiline opening hours in pickup map details */
    var html = '<div class="cust-delivery-map-popup">';
    if (loc.city) html += '<div class="cust-delivery-map-popup__city">' + escapeHtml(loc.city) + '</div>';
    if (loc.address) html += '<div class="cust-delivery-map-popup__address">' + escapeHtml(loc.address) + '</div>';
    var openingHours = String(loc.openingHours || '').trim();
    if (openingHours) {
      html += '<div class="cust-delivery-map-popup__hours"><div>' +
        escapeHtml(this.mapEl.getAttribute('data-opening-hours-label') || '') + '</div><div>' +
        escapeHtml(openingHours).replace(/\r\n|\r|\n/g, '<br>') + '</div></div>';
    }
    html += '</div>';
    return html;
    /* InsCoder WANG.J 2026-10-29 E + Include escaped multiline opening hours in pickup map details */
  };

  DeliveryMethod.prototype.showMapError = function (message) {
    if (!this.mapEl) return;
    var errorEl = this.mapEl.querySelector('.cust-delivery-modal__map-error');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'cust-delivery-modal__map-error';
      this.mapEl.appendChild(errorEl);
    }
    errorEl.textContent = message || this.mapConsentHint;
    errorEl.hidden = false;
  };

  DeliveryMethod.prototype.hideMapError = function () {
    if (!this.mapEl) return;
    var errorEl = this.mapEl.querySelector('.cust-delivery-modal__map-error');
    if (errorEl) errorEl.hidden = true;
  };

  DeliveryMethod.prototype.refreshMapSize = function () {
    if (!this.map || !window.google || !window.google.maps) return;
    window.google.maps.event.trigger(this.map, 'resize');
    if (!this.root.querySelector('[data-pickup-location].is-active')) this.fitAllLocations();
  };

  /* InsCoder WANG.J 2026-10-29 B + Fit the overview to all configured pickup markers */
  DeliveryMethod.prototype.fitAllLocations = function () {
    if (!this.map || !this.markers.length || !this.mapEl.clientWidth || !this.mapEl.clientHeight) return;
    if (this.locationBounds.getNorthEast().equals(this.locationBounds.getSouthWest())) {
      this.map.setCenter(this.markers[0].marker.getPosition());
      this.map.setZoom(10);
    } else {
      this.map.fitBounds(this.locationBounds, { top: 80, right: 32, bottom: 32, left: 32 });
    }
  };

  DeliveryMethod.prototype.showAllLocations = function () {
    this.locationBtns.forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    if (this.locationSelect) this.locationSelect.value = '';
    if (this.infoWindow) this.infoWindow.close();
    this.fitAllLocations();
  };
  /* InsCoder WANG.J 2026-10-29 E + Fit the overview to all configured pickup markers */

  DeliveryMethod.prototype.initMap = function () {
    var self = this;
    if (this.map) {
      this.refreshMapSize();
      return;
    }
    if (!this.mapEl || this._mapInitStarted) return;
    this._mapInitStarted = true;
    this.hideMapError();

    loadGoogleMaps(this.apiKey)
      .then(function (maps) {
        if (self._destroyed) return;

        self.map = new maps.Map(self.mapEl, {
          center: { lat: 51.1657, lng: 10.4515 },
          zoom: 6,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false
        });
        self.infoWindow = new maps.InfoWindow();
        /* InsCoder WANG.J 2026-10-29 B + Keep the complete pickup info window inside short map viewports */
        self.infoWindow.addListener('domready', function () {
          cancelAnimationFrame(self._popupFrame);
          self._popupFrame = requestAnimationFrame(function () {
            if (self._destroyed) return;
            var popup = self.mapEl.querySelector('.cust-delivery-map-popup');
            var dialog = popup && popup.closest('.gm-style-iw-c');
            if (!dialog) return;
            var offset = dialog.getBoundingClientRect().top - self.mapEl.getBoundingClientRect().top - 16;
            if (offset < 0) self.map.panBy(0, offset);
          });
        });
        /* InsCoder WANG.J 2026-10-29 E + Keep the complete pickup info window inside short map viewports */
        self.markers = [];
        self.locationBounds = new maps.LatLngBounds();

        self.locations.forEach(function (loc) {
          if (!hasValidCoordinates(loc)) return;
          self.locationBounds.extend({ lat: loc.lat, lng: loc.lng });
          var marker = new maps.Marker({
            position: { lat: loc.lat, lng: loc.lng },
            map: self.map,
            title: loc.city || loc.address
          });
          marker.addListener('click', function () {
            var btn = self.root.querySelector(
              '[data-pickup-location][data-index="' + loc.index + '"]'
            );
            if (btn) self.activateLocation(btn, true);
          });
          self.markers.push({ marker: marker, loc: loc });
        });

        self._mapResizeTimer = setTimeout(function () {
          self.refreshMapSize();
        }, 50);
        if (window.ResizeObserver) {
          self._mapResizeObserver = new ResizeObserver(function () {
            self.refreshMapSize();
          });
          self._mapResizeObserver.observe(self.mapEl);
        }

        var activeBtn = self.root.querySelector('[data-pickup-location].is-active');
        if (activeBtn) self.activateLocation(activeBtn, true);
      })
      .catch(function (err) {
        if (self._destroyed) return;
        console.error('[cust-delivery-method] Google Maps failed to load', err);
        self._mapInitStarted = false;
        self.showMapError(self.mapConsentHint);
        bindConsentRetry(function () {
          if (!self._destroyed && !self.map) self.initMap();
        });
      });
  };

  DeliveryMethod.prototype.activateLocation = function (btn, fromMap) {
    if (!btn) return;

    this.locationBtns.forEach(function (el) {
      el.classList.toggle('is-active', el === btn);
      el.setAttribute('aria-pressed', el === btn ? 'true' : 'false');
    });

    var index = btn.getAttribute('data-index');
    var lat = parseFloat(btn.getAttribute('data-lat'));
    var lng = parseFloat(btn.getAttribute('data-lng'));

    if (this.infoWindow) this.infoWindow.close();
    if (this.map && hasValidCoordinates({ lat: lat, lng: lng })) {
      this.map.setZoom(12);
      this.map.setCenter({ lat: lat, lng: lng });

      var markerEntry = this.markers.find(function (entry) {
        return String(entry.loc.index) === String(index);
      });

      if (markerEntry && markerEntry.marker && this.infoWindow) {
        this.infoWindow.setContent(this.buildPopupHtml(markerEntry.loc));
        this.infoWindow.open(this.map, markerEntry.marker);
      }
    }

    if (this.locationSelect && index != null) {
      this.locationSelect.value = index;
    }

    if (!fromMap) {
      btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  /* InsCoder WANG.J 2026-10-29 B + Release map observers and listeners on editor section unload */
  DeliveryMethod.prototype.destroy = function () {
    this._destroyed = true;
    clearTimeout(this._mapResizeTimer);
    cancelAnimationFrame(this._popupFrame);
    this._listeners.forEach(function (listener) {
      listener.element.removeEventListener(listener.type, listener.handler);
    });
    this._listeners = [];
    if (this._mapResizeObserver) this._mapResizeObserver.disconnect();
    if (this.infoWindow) {
      this.infoWindow.close();
      window.google.maps.event.clearInstanceListeners(this.infoWindow);
    }
    this.markers.forEach(function (entry) {
      window.google.maps.event.clearInstanceListeners(entry.marker);
      entry.marker.setMap(null);
    });
    if (this.map) window.google.maps.event.clearInstanceListeners(this.map);
    this.root.__custDeliveryMethod = null;
    this.root.__custDeliveryMethodInit = false;
  };
  /* InsCoder WANG.J 2026-10-29 E + Release map observers and listeners on editor section unload */

  function initAll() {
    document.querySelectorAll('[data-cust-delivery-method]').forEach(function (root) {
      if (root.__custDeliveryMethodInit) return;
      root.__custDeliveryMethodInit = true;
      root.__custDeliveryMethod = new DeliveryMethod(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-cust-delivery-method]').forEach(function (root) {
      if (root.__custDeliveryMethod) root.__custDeliveryMethod.destroy();
    });
  });
})();
